import React, { createContext, useState, useContext, ReactNode } from 'react';

interface SidebarContextProps {
  collapsed: boolean;
  setCollapsed: React.Dispatch<React.SetStateAction<boolean>>;
  touched: boolean;
  setTouched: React.Dispatch<React.SetStateAction<boolean>>;
  toggleCollapse: () => void;
  collapseSidebar: () => void;
}

// Create a context
const SidebarContext = createContext<SidebarContextProps | undefined>(
  undefined
);

interface SidebarProviderProps {
  children: ReactNode;
}

// Create a provider component
export const SidebarProvider: React.FC<SidebarProviderProps> = ({
  children,
}) => {
  const [collapsed, setCollapsed] = useState<boolean>(false);
  const [touched, setTouched] = useState<boolean>(false);

  const toggleCollapse = () => {
    setCollapsed((prev) => !prev);
    setTouched(true);
  };

  const collapseSidebar = () => {
    setCollapsed(true);
    setTouched(false); // Optional: reset touched state if needed
  };

  return (
    <SidebarContext.Provider
      value={{
        collapsed,
        setCollapsed,
        touched,
        setTouched,
        collapseSidebar,
        toggleCollapse,
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
};

// Custom hook to use the SidebarContext
export const useSidebar = (): SidebarContextProps => {
  const context = useContext(SidebarContext);
  if (context === undefined) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
};
